/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import WebhookListBody from "components/WebhookComponents/WebhookListBody/WebhookListBody";

const WebhookList = () => {
  useEffect(() => {
    document.title = "Webhook List";
  }, []);

  return (
    <main id="app">
      <Header moduleName="webhook" />
      <WebhookListBody />
    </main>
  );
};

export default WebhookList;
